export default __webpack_public_path__ + "static/mini-3-fbdc0506b2cffaf15d5364b2856bc992.png";